// C:\Users\purplehat\Desktop\payment-cookie-system\frontend\src\services\api.js

import axios from 'axios';

const API_URL = 'https://bckend-1-fi3u.onrender.com/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 300000
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error('❌ Error', error.response.status, ':', error.response.data, '→', error.config?.url);
    } else if (error.request) {
      console.error('❌ Sin respuesta del servidor:', error.message);
    } else {
      console.error('❌ Error:', error.message);
    }

    const url = error.config?.url || '';
    const isAuthEndpoint = url.includes('/auth/login') || url.includes('/auth/register');

    // ✅ Solo actuar en 401 de endpoints protegidos, nunca en login/register
    if (error.response?.status === 401 && !isAuthEndpoint) {
      const token = localStorage.getItem('token');

      // ✅ Solo limpiar si había token Y no estamos ya en /login (evita bucle)
      if (token && window.location.pathname !== '/login') {
        console.warn('🔒 401 en', url, '→ cerrando sesión una sola vez');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.replace('/login');
      }
    }

    return Promise.reject(error);
  }
);

export default api;
